import React from 'react';
import { Box } from '@mui/material';
import { useStyles } from './ExerciseSlidePanel.styles';
import theme from '../../../styles/theme';

interface ExerciseSlidePanelProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function ExerciseSlidePanel({
  open,
  onClose,
  children,
}: ExerciseSlidePanelProps) {
  const { classes } = useStyles(theme);

  return (
    <>
      <div
        className={`${classes.overlay} ${open ? classes.overlayVisible : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`${classes.panel} ${open ? classes.panelVisible : ''}`}
        role="dialog"
        aria-modal="true">
        <Box className={classes.content}>{children}</Box>
      </div>
    </>
  );
}
